import { ProgramDetailInfo } from '@type/buzzkuri/program-detail'
import React from 'react'
import { ProgramBaseInfo } from './ProgramBaseInfo'

type Props = ProgramDetailInfo

export const ProgramDetail = ({ programBase }: Props): JSX.Element => {
  return <ProgramBaseInfo {...programBase} />
}
